import { Page } from '../../../../../components/page/page';
import { DeleteModal } from '../../../../../features/delete-modal/delete-modal';
import { HasAccess } from '../../../../../features/has-access/has-access';
import { RestoreModal } from '../../../../../features/restore-modal/restore-modal';
import { QrCards } from './qr-cards/qr-cards';
import { QrCodeModal } from './qr-code-modal/qr-code-modal';
import { QrsControls } from './qr-controls/qr-controls';
import s from './qr-list.module.css';
import { QrTable } from './qr-table/qr-table';
import { useQrList } from './use-qr-list';

export const QrList = () => {
  const {
    handleCloseQrModal,
    isOpenQrModal,
    t,
    deleteQrCode,
    restoreQrCode,
    viewStyle,
    pagination,
    handleEnd,
  } = useQrList();

  return (
    <Page className={s.page}>
      <div className={s.header}>
        <h2>
          {t('QR-коды')} ({pagination?.count})
        </h2>
        <QrsControls />
      </div>

      {viewStyle === 'table' ? <QrTable /> : <QrCards onEnd={handleEnd} />}

      <HasAccess service="qr" permissions={['write']}>
        <DeleteModal onSubmit={deleteQrCode} />
        <RestoreModal onSubmit={restoreQrCode} />
      </HasAccess>
      {isOpenQrModal && <QrCodeModal onClose={() => handleCloseQrModal(['qrId', 'qrName'])} />}
    </Page>
  );
};
